import { Box, Button, Stack, StackProps } from "@mui/material"
import { SearchWordField } from "components/controls/searchWordField"
import { useUserSession } from "features/session/context"
import { PlusIcon } from "shared/icons"

type SearchListHeaderProps = {
	searchWord: string
	setSearchWord: (word: string) => void
	onOpenNewSearchDialog: () => void
	isSmallMedia: boolean
} & StackProps
export const SearchListHeader = ({
	searchWord,
	setSearchWord,
	onOpenNewSearchDialog,
	isSmallMedia,
	...others
}: SearchListHeaderProps) => {
	const { isGeneral } = useUserSession()
	return (
		<Stack
			direction="row"
			padding={2}
			spacing={1}
			alignItems="center"
			flexWrap="wrap"
			useFlexGap
			{...others}
		>
			<Button
				fullWidth={isSmallMedia}
				disabled={!isGeneral}
				variant="contained"
				startIcon={<PlusIcon />}
				size="large"
				sx={{ whiteSpace: 'nowrap' }}
				onClick={() => onOpenNewSearchDialog()}
			>
				分析依頼を登録
			</Button>
			{isSmallMedia ? <></> : <Box flexGrow={1} />}
			<SearchWordField
				id="search-word-search"
				fullWidth={isSmallMedia}
				searchWord={searchWord}
				onChangeSearchWord={setSearchWord}
			/>
		</Stack>		
	)
}
